"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.get = undefined;

var _reselect = require("reselect");

var _raw = require("../raw");

var RawChar = _interopRequireWildcard(_raw);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var get = exports.get = (0, _reselect.createSelector)(RawChar.localState, function (s) {
  return s.units || {};
});
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uL3NyYy9zZWxlY3RvcnMvZmlyZWJhc2UvY2hhcmFjdGVyczIvdW5pdHMvcmF3LmpzIl0sIm5hbWVzIjpbIlJhd0NoYXIiLCJnZXQiLCJsb2NhbFN0YXRlIiwicyIsInVuaXRzIl0sIm1hcHBpbmdzIjoiOzs7Ozs7O0FBQ0E7O0FBQ0E7O0lBQVlBLE87Ozs7QUFHTCxJQUFNQyxvQkFBTSw4QkFBZUQsUUFBUUUsVUFBdkIsRUFBbUM7QUFBQSxTQUFLQyxFQUFFQyxLQUFGLElBQVcsRUFBaEI7QUFBQSxDQUFuQyxDQUFaIiwiZmlsZSI6InJhdy5qcyIsInNvdXJjZXNDb250ZW50IjpbIi8vIEBmbG93XG5pbXBvcnQge2NyZWF0ZVNlbGVjdG9yfSBmcm9tIFwicmVzZWxlY3RcIlxuaW1wb3J0ICogYXMgUmF3Q2hhciBmcm9tIFwiLi4vcmF3XCJcblxuZXhwb3J0IHR5cGUgU3RhdGUgPSB7W3VuaXROYW1lOiBzdHJpbmddOiBPYmplY3R9XG5leHBvcnQgY29uc3QgZ2V0ID0gY3JlYXRlU2VsZWN0b3IoUmF3Q2hhci5sb2NhbFN0YXRlLCBzID0+IHMudW5pdHMgfHwge30pXG4iXX0=


//////////////////
// WEBPACK FOOTER
// ../core/lib/selectors/firebase/characters2/units/raw.js
// module id = 220
// module chunks = 0